import { Link } from "react-router-dom";
import { MapPin, Phone, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-20 bg-[#0A0C0A] text-[#EAEAEA] border-t-4 border-[#2E7D32]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-[#2E7D32] flex items-center justify-center font-heading-te text-2xl">న</div>
            <div>
              <div className="font-heading-te text-2xl font-bold">నల్లమల వాయిస్</div>
              <div className="font-body-te text-xs text-[#A0A0A0] italic">
                ప్రకృతి నేర్పిన బాట... సమాజ మేలే మన మాట
              </div>
            </div>
          </div>
          <p className="mt-5 font-body-te text-sm text-[#A0A0A0] leading-relaxed">
            ఉమ్మడి పాలమూరు జిల్లా ప్రజల గొంతుక. తాజా వార్తలు, సమాజ మేలుకోసం విశ్వసనీయ కథనాలు.
          </p>
        </div>

        <div>
          <h3 className="font-heading-te text-xl font-bold mb-4 text-white">విభాగాలు</h3>
          <ul className="space-y-2 font-body-te text-sm">
            {[
              ["రాజకీయం", "/category/politics"],
              ["జిల్లా వార్తలు", "/category/district"],
              ["వ్యవసాయం", "/category/agriculture"],
              ["క్రైమ్", "/category/crime"],
              ["సినిమా/వినోదం", "/category/cinema"],
              ["ప్రత్యేక కథనాలు", "/category/special"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-[#A0A0A0] hover:text-[#2E7D32] transition-colors" data-testid={`footer-link-${to.split("/").pop()}`}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading-te text-xl font-bold mb-4 text-white" data-testid="footer-contact-title">సంప్రదించండి</h3>
          <ul className="space-y-3 font-body-te text-sm text-[#EAEAEA]">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#2E7D32] shrink-0" />
              <span>ఉమ్మడి పాలమూరు, తెలంగాణ &amp; ఆంధ్రప్రదేశ్</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#2E7D32]" />
              <a href="tel:9010226164" className="hover:text-[#2E7D32]" data-testid="footer-phone">9010226164</a>
            </li>
            <li className="flex items-center gap-3">
              <Globe className="w-4 h-4 text-[#2E7D32]" />
              <a href="https://nallamalavoice.com" className="hover:text-[#2E7D32]" data-testid="footer-website">nallamalavoice.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1F221F] py-5 text-center font-body-te text-xs text-[#7A7A7A]">
        © {new Date().getFullYear()} నల్లమల వాయిస్ · All rights reserved
        <span className="mx-2">·</span>
        <Link to="/admin/login" className="hover:text-[#2E7D32]" data-testid="admin-login-link">Admin</Link>
      </div>
    </footer>
  );
}
